module.exports = __webpack_public_path__ + "img/red-desert-decal-01.e4348ad9.png";